module.exports = __webpack_public_path__ + "static/img/zip-file-format.e4c2357.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/document/zip-file-format.png
// module id = hdu0
// module chunks = 4